import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import LinearProgress from '@material-ui/core/LinearProgress';
import { makeStyles } from '@material-ui/core/styles';
import FavoriteIcon from '@material-ui/icons/Favorite';
import RestoreIcon from '@material-ui/icons/Restore';
import SettingsIcon from '@material-ui/icons/Settings';
import React from 'react';
import { useHistory } from "react-router-dom";
import { useImmutableContext } from 'store';


const useStyles = makeStyles({
  root: {
    width: '100%',
    position: 'fixed',
    bottom: 0,
    zIndex: 99
  },
  progress: {
    position: 'fixed',
    bottom: 0,
    width: '100%',
    zIndex: 100
  },
});

export default function SimpleBottomNavigation(props: any) {
  const classes = useStyles();
  // location.pathname
  const [value, setValue] = React.useState(0);
  const { state } = useImmutableContext()
  const history = useHistory()
  return (
    <>
      <BottomNavigation
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
          switch (newValue) {
            case 0:
              return history.push('')
            case 1:
              return history.push('fav')
            case 2:
              return history.push('setting')
            default:
              return history.push('')
          }
        }}
        showLabels
        className={classes.root}
      >
        <BottomNavigationAction label="Recents" icon={<RestoreIcon />} />
        <BottomNavigationAction label="Favorites" icon={<FavoriteIcon />} />
        <BottomNavigationAction label="Settings" icon={<SettingsIcon />} />
      </BottomNavigation>
      {state.status.loading && <LinearProgress className={classes.progress} />}
    </>
  );
}
